import React, { useEffect, useState } from "react";
// Iconos
import {
  FaMusic, FaFutbol, FaTheaterMasks, FaUsers,
  FaStar, FaLayerGroup, FaQuestionCircle
} from "react-icons/fa";
import "../styles/MainContent.css";
import LoadingScreen from "./LoadingScreen";
import { useAuth } from "react-oidc-context";
import Modal from "./Modal";
// IMPORTANTE: Importamos desde el servicio de catálogo
import { getEventTypes } from "../services/catalog";

// Diccionario para convertir texto del backend a componentes visuales
const ICON_MAP = {
  "CONCIERTO": <FaMusic />,
  "music": <FaMusic />,
  "festival": <FaMusic />,
  "sports": <FaFutbol />,
  "DEPORTE": <FaFutbol />,
  "theater": <FaTheaterMasks />,
  "TEATRO": <FaTheaterMasks />,
  "family": <FaUsers />,
  "FAMILIAR": <FaUsers />,
  "special": <FaStar />,
  "multi": <FaLayerGroup />,
  "other": <FaQuestionCircle />
};

const MainContent = () => {
  const auth = useAuth();
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedTypeData, setSelectedTypeData] = useState(null);
  const [cards, setCards] = useState([]); // Aquí guardamos lo que viene de la API
  const [loading, setLoading] = useState(false);

  // EFECTO: Cargar tarjetas al iniciar
  useEffect(() => {
    if (auth.isAuthenticated) {
      setLoading(true);
      getEventTypes()
        .then(data => {
            console.log("Datos del catálogo:", data); // Debug para ver qué llega
            setCards(data);
        })
        .catch(err => console.error("Error cargando dashboard:", err))
        .finally(() => setLoading(false));
    }
  }, [auth.isAuthenticated]);

  const openModal = (typeData) => {
    setSelectedTypeData(typeData);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedTypeData(null);
    setModalOpen(false);
  };

  if (loading) {
    return <LoadingScreen text="Cargando información..." />;
  };

  return (
    <div className="main-content">
      {/* Grid de Tarjetas */}
      <div className="cards-grid">
        {cards.map((item, index) => (
          <button
            key={item.event_type || index}
            className="team-button card-style"
            onClick={() => openModal(item)}
          >
            <div className="card-icon">
              {/* Busca el icono por nombre, si no existe pone el default */}
              {ICON_MAP[item.icon] || ICON_MAP[item.event_type] || <FaQuestionCircle />}
            </div>
            <div className="card-info">
              <h3>{item.label}</h3>
              <span className="badge-count">{item.count_events} eventos</span>
            </div>
          </button>
        ))}
      </div>

      {/* Modal Dinámico */}
      {selectedTypeData && (
        <Modal
          isOpen={isModalOpen}
          onClose={closeModal}
          eventTypeData={selectedTypeData}
        />
      )}
    </div>
  );
};

export default MainContent;
